import React, { Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, Preload, useGLTF } from "@react-three/drei";

import CanvasLoader from "../Loader";

const Earth = () => {
  const earth = useGLTF("./planet/scene.gltf");

  return (<mesh><hemisphereLight intensity={0.55} groundColor='black' />
  <spotLight
    position={[-50, 50, 50]}
    angle={0.35}
    penumbra={1}
    intensity={2}
    castShadow
    shadow-mapSize={1024}
  />
  <pointLight intensity={15} />
    <primitive object={earth.scene} scale={8} position-y={-15} rotation-y={-0.2} position-x={-5} rotation-x={-0.05}/>
    </mesh>);
};

const EarthCanvas = () => {
  return (
    <Canvas
      
      frameloop='demand'
      dpr={[1, 2]}
      gl={{ preserveDrawingBuffer: false }}
      camera={{
        fov: 45,
        near: 1.1,
        far: 200,
        position: [1, 3, 110],
      }}
    >
      <Suspense fallback={<CanvasLoader />}>
        <OrbitControls
          
          enableZoom={false}
          maxPolarAngle={Math.PI / 2}
          minPolarAngle={Math.PI / 2}
        />
        <Earth />

        <Preload all />
      </Suspense>
    </Canvas>
  );
};

export default EarthCanvas;
